// removed by extract-text-webpack-plugin
module.exports = {"services":"Services-m__services___DIEuX","services__loading":"Services-m__services__loading___3qvND","servicesLoading":"Services-m__services__loading___3qvND"};


//////////////////
// WEBPACK FOOTER
// ./components/services/Services.m.sass
// module id = fx6v
// module chunks = 0